<ng-container *transloco="let t">
<div class="container">
  <form #requestCallForm="ngForm" novalidate (ngSubmit)="submit()">
    <div class="row p-4 mb-3">
      <div class="form-group mb-3">
        <h4>{{ t('portal.requestCall.title') }}</h4>
      </div>
      <div class="form-group mb-3">
        <label class="form-label" for="bestContactMumber"
          >{{ t('portal.requestCall.preferredPhone') }}</label
        >
        <input
          class="form-control"
          type="tel"
          id="bestContactMumber"
          name="bestContactMumber"
          [(ngModel)]="requestACall.bestContactMumber"
        />
      </div>
      <div class="form-group mb-3">
        <label class="form-label" for="bestCallbackTime">{{ t('portal.requestCall.callbackTime') }}</label>
        <input
          class="form-control"
          type="datetime-local"
          id="bestCallbackTime"
          name="bestCallbackTime"
          [ngModel]="requestACall.bestCallbackTime"
          (ngModelChange)="bestCallbackTimeChanged($event)"
        />
      </div>
      <div class="form-group mb-3">
        <label class="form-label" for="note">{{ t('portal.requestCall.note') }}</label>
        <textarea
          class="form-control"
          rows="3"
          id="note"
          name="note"
          [(ngModel)]="requestACall.note"
        ></textarea>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-sm bp-primary-bg-color" type="submit">{{ t('common.submit') }}</button>
      </div>
    </div>
  </form>
</div>
</ng-container>
